<template>
  <div class="container">
    <div class="head-btns">
      <create-card-dialog @change="handleSearch">
        <el-button class="mwow-button-filled success">新增</el-button>
      </create-card-dialog>
    </div>
    <el-form size="mini" :model="searchInfo" inline>
      <el-form-item label="名称:">
        <el-input
          v-model="searchInfo.card_name"
          placeholder="请输入名称"
          @change="handleSearch"
          clearable
          @clear="handleSearch"
          prefix-icon="el-icon-search"
          maxlength="30"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="名称" prop="card_name"></el-table-column>
      <el-table-column label="积分分值" prop="integral"></el-table-column>
      <el-table-column label="生成数量" prop="total_num"></el-table-column>
      <el-table-column label="已使用" prop="activate_num"></el-table-column>
      <el-table-column label="剩余" prop="integral">
        <template slot-scope="scope">{{
          scope.row.total_num - scope.row.activate_num
        }}</template>
      </el-table-column>
      <el-table-column label="备注" prop="remark">
        <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="160" align="center">
        <template slot-scope="scope">
          <el-button
            style="margin-right: 12px"
            class="mwow-button primary"
            v-if="!scope.row.loading"
            @click="downloadQRCode(scope)"
            >下载二维码</el-button
          >
          <el-button
            style="margin-right: 12px; background-color: #f7f7f7 !important"
            class="mwow-button info"
            disabled
            v-else
            >生成中<i class="el-icon-loading"></i
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { getIntegralCardListApi, exportIntegralCardApi } from "@/api/integral";
import { exportLoop } from "@/utils/export";
import createCardDialog from "./createCardDialog.vue";
export default {
  props: ["visible"],
  components: {
    createCardDialog,
  },
  data() {
    return {
      searchInfo: {},
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    getList(page) {
      const params = {
        page: page.page,
        page_size: page.page_size,
      };
      if (this.searchInfo.card_name) {
        params.card_name = this.searchInfo.card_name;
      }
      getIntegralCardListApi(params).then((res) => {
        res.data.list.map((item) => {
          item.loading = false;
        });
        this.tableData = res.data.list;
        this.page = res.data.page;
        this.total = res.data.total;
      });
    },
    downloadQRCode(scope) {
      // 点击限制
      this.tableData[scope.$index].loading = true;
      exportIntegralCardApi({
        card_id: scope.row.card_id,
      }).then((res) => {
        exportLoop(res.data.task_id, 1000, () => {
          this.tableData[scope.$index].loading = false;
        });
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.head-btns {
  margin-bottom: 13px;
}
</style>
